export const ageMethod = "age nearest";
export const gateway = "https://qat-standard-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/standard";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzdGFuZGFyZCIsIm5hbWUiOiJzdGFuZGFyZCIsImlhdCI6MTc4MDU4MTE0MSwiZXhwIjoxOTM4MzY5MTQxfQ.9bPOzMjOwuDCoHBFBP_ozNrLBZEmPtYKL6x6aN5OtHQ";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-standard-shopper.link-nonprod.wawanesalife.com": {
		a: {
			accessibilityLink: "https://www.standardinsurance.ca/accessibility-at-the-standard/",
			approve_company: "Link Platform",
			approve_user: "link_standard",
			brands: [
				"qat-standard-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "standard",
			broker_formatted_name: "Standard Insurance",
			email: "SFA@standardinsurance.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map3": [
					"339 Main Street",
					"Creighton",
					"SK",
					"S0P 0A0",
				],
				"map2": [
					"200-330 St. Mary Avenue",
					"Winnipeg",
					"MB",
					"R3C 2L2",
				],
				"map1": [
					"319 2nd Street S",
					"Kenora",
					"ON",
					"P9N 3X8",
				],
				"map7": [
					"34 Front Street",
					"Sioux Lookout",
					"ON",
					"P8T 1A1",
				],
				"map6": [
					"179 Howey Street",
					"Red Lake",
					"ON",
					"P0V 2M0",
				],
				"map5": [
					"86 Main Street",
					"Flin Flon",
					"MB",
					"R8A 1J8",
				],
				"map4": [
					"73 King Street",
					"Dryden",
					"ON",
					"P8N 1B7",
				],
				"map9": [
					"130 2nd St E",
					"Fort Frances",
					"ON",
					"P9A 1M5",
				],
				"map8": [
					"102-920 Tungsten Street",
					"Thunder Bay",
					"ON",
					"P7B 5Z6",
				],
			},
			menuPhone: "button",
			phone: "1-844-936-3216",
			privacyLink: "https://www.standardinsurance.ca/privacy-policy/",
			website: "https://www.standardinsurance.ca/",
			scope: "standard#branding#qat-standard-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-standard-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			accessibilityLink: "https://www.standardinsurance.ca/accessibility-at-the-standard/",
			approve_company: "Link Platform",
			approve_user: "link_standard",
			brands: [
				"qat-standard-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "standard",
			broker_formatted_name: "Standard Insurance",
			email: "SFA@standardinsurance.ca",
			environment: "qat",
			environment_id: "qat",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map3": [
					"339 Main Street",
					"Creighton",
					"SK",
					"S0P 0A0",
				],
				"map2": [
					"200-330 St. Mary Avenue",
					"Winnipeg",
					"MB",
					"R3C 2L2",
				],
				"map1": [
					"319 2nd Street S",
					"Kenora",
					"ON",
					"P9N 3X8",
				],
				"map7": [
					"34 Front Street",
					"Sioux Lookout",
					"ON",
					"P8T 1A1",
				],
				"map6": [
					"179 Howey Street",
					"Red Lake",
					"ON",
					"P0V 2M0",
				],
				"map5": [
					"86 Main Street",
					"Flin Flon",
					"MB",
					"R8A 1J8",
				],
				"map4": [
					"73 King Street",
					"Dryden",
					"ON",
					"P8N 1B7",
				],
				"map9": [
					"130 2nd St E",
					"Fort Frances",
					"ON",
					"P9A 1M5",
				],
				"map8": [
					"102-920 Tungsten Street",
					"Thunder Bay",
					"ON",
					"P7B 5Z6",
				],
			},
			menuPhone: "button",
			phone: "1-844-936-3216",
			privacyLink: "https://www.standardinsurance.ca/privacy-policy/",
			website: "https://www.standardinsurance.ca/",
			scope: "standard#branding#qat-standard-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-standard-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 13:52:21 GMT+0000 (Coordinated Universal Time)
